import React from 'react';
import { Card, Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { ACLCheck } from 'shared/Helpers';

/**
 * ClientAdminCard component that renders the Client Admin section with navigation cards
 * for managing clients, client accounts, and users.
 * @returns {React.ReactElement | null} JSX element containing the Client Admin card section or null if user lacks permissions
 */
const ClientAdminCard: React.FC = () => {
  return (
    <>
      {ACLCheck(['read:client_admin', 'create:client_admin', 'update:client_admin']) && (
        <Card title="Client Admin" bordered={false} className="bg-gray-200 mb-4 rounded-xl">
          <Row gutter={[24, 16]}>
            <Col span={6}>
              <Link to={'clients'}>
                <Card title="Clients">{'Manage Clients and Client Metadata'}</Card>
              </Link>
            </Col>
            <Col span={6}>
              <Link to={'account_admin'}>
                <Card title="Client Account Admin">{'Manage Client Accounts and Users'}</Card>
              </Link>
            </Col>
            <Col span={6}>
              <Link to={'users'}>
                <Card title="Users">{'View Vantage Users'}</Card>
              </Link>
            </Col>
            <Col span={6}>
              <Link to={'supplier_mapping'}>
                <Card title="Supplier Mapping">{"Map Client's Suppliers to Vantage Suppliers"}</Card>
              </Link>
            </Col>
            <Col span={6}>
              <Link to={'global_api_limits'}>
                <Card title="Global API Limits">{'Set global limits for API Requests'}</Card>
              </Link>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};

export default ClientAdminCard;
